import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import MatureToggle from '../../../MatureToggle';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import ThemeToggle from '../../_partials/ThemeToggle';
import userMenuStyles from './UserMenu.scss';
export function getMatureToggle(matureContent, toggleMature, t) {
    return {
        label: (React.createElement("div", { className: userMenuStyles['two-side-label'] },
            React.createElement("span", { id: "user-menu-mature-label", onClick: function () { return toggleMature(matureContent); } }, t('siteHeaderMobile.userMenu.matureContent')),
            React.createElement(MatureToggle, { size: "medium", value: matureContent, onChange: toggleMature, "aria-labelledby": "user-menu-mature-label" }))),
        biData: BiData({
            evid: 702,
            menu_item: 'toggle_mature',
            menu_name: 'profile',
            toggle_value: !matureContent ? 'mature_on' : 'mature_off',
        }),
    };
}
export function getThemeToggle(theme, toggleTheme, t) {
    return {
        label: (React.createElement("div", { className: userMenuStyles['two-side-label'] },
            React.createElement("span", null, t('siteHeaderMobile.userMenu.mode')),
            React.createElement(PlainButtonOrLink, { "aria-label": t('siteHeader.userMenu.themeDark'), "aria-pressed": theme === ThemeOptions.DARK, tabIndex: 0, onClick: function () { return toggleTheme(); } },
                React.createElement(ThemeToggle, { className: userMenuStyles['theme-toggle'] })))),
        biData: BiData({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: theme === 'light' ? 'dark' : 'light',
        }),
    };
}
//# sourceMappingURL=menuItemHelpers.js.map